import {AbstractModel} from '../abstract-model';
import {DateStat} from './date-stat';

export class PartnerHistory extends AbstractModel {
  last12Months: DateStat[] = [];
  last30days: DateStat[] = [];

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.last12Months) {
      this.last12Months = input.last12Months.map((data: any) => new DateStat().deserialize(data));
    }

    if (input.last30days) {
      this.last30days = input.last30days.map((data: any) => new DateStat().deserialize(data));
    }

    return this;
  }
}
